var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoMatchHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icNoMatchHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.70702156,15.9106578 C4.5127172,13.9710956 6.88687117,13 9.26424152,13 C11.6416119,13 14.0277124,13.9710996 15.8334463,15.9106578 L17.9992243,18.2440965 L20.1650406,15.922939 C23.7764701,12.0437401 29.6800365,12.0438266 33.2914278,15.922939 C36.9028574,19.8020554 36.9028574,26.0321658 33.2914278,29.9112862 C28.3767484,35.1903007 23.464289,40.4752103 18.5496479,45.7541069 C18.4049882,45.9110695 18.2037599,46 17.993251,46 C17.7827422,46 17.5815138,45.9110695 17.4368541,45.7541069 L2.70702156,29.8989853 C-0.900272546,26.0168624 -0.904407902,19.7897113 2.70702156,15.9106578 Z M30.2783157,1.32302626 C31.1310053,0.441407113 32.2521336,0 33.3747807,2.03086139e-14 C34.4974278,2.03086139e-14 35.6241975,0.441408899 36.4769052,1.32302626 L37.4996337,2.38368022 L38.5223803,1.32860865 C40.2277776,-0.434663586 43.0155728,-0.434624286 44.720952,1.32860865 C46.4263493,3.09184337 46.4263493,5.92371175 44.720952,7.68694826 C42.4001312,10.0865003 40.0803587,12.4887319 37.7595559,14.8882304 C37.6912444,14.959577 37.5962199,15 37.496813,15 C37.397406,15 37.3023815,14.959577 37.23407,14.8882304 L30.2783157,7.68135693 C28.5748713,5.91675564 28.5729185,3.0862324 30.2783157,1.32302626 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-481.000000, -2039.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LeftSide-Bar",
    transform: "translate(358.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-V2",
    transform: "translate(0.000000, 528.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects-Matches---Emp-state",
    transform: "translate(0.000000, 1245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospects---Views"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-matches-yet",
    transform: "translate(103.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart-icon",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icNoMatchHS",
    fill: "#CECECE",
    xlinkHref: "#path-1"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoMatchHs);
export default __webpack_public_path__ + "static/media/icNoMatchHS.4a81903b9690deeb5c083b15d5e032bc.svg";
export { ForwardRef as ReactComponent };